<template>
  <div class="update-package-wrapper">
    <div class="header">
      <span class="label">更新包日志</span>
      <el-date-picker
        v-model="date"
        type="date"
        placeholder="选择日期"
        size="small"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
        @change="dateChange"
      ></el-date-picker>
      <span class="label">更新包类型</span>
      <el-select v-model="upgrade_type" placeholder="请选择" size="small" @change="upgradeTypeChange">
        <el-option
          label="增量包"
          value="realtime"
          v-if="version === 'blackipv2' || version === 'blackipv3'"
        ></el-option>
        <el-option label="增量包" value="upgrade" v-if="version=== 'blackip'"></el-option>
        <el-option label="全量包" value="full"></el-option>
      </el-select>
    </div>
    <package-table
      style="margin-top:19px;"
      :data="tableData"
      :type="upgrade_type"
      :loading="loading"
    ></package-table>
    <div class="pagination-box" v-if="total>10">
      <el-pagination
        background=""
        layout="prev, pager, next,jumper"
        :total="total"
        :current-page="parmas.page"
        @current-change="pageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/util/common'
import PackageTable from './table.vue'
import { getIpUpdatePackageData } from '@/services/interface'
export default {
  components: {
    PackageTable
  },
  props: {
    version: {
      type: String
    }
  },
  data () {
    return {
      date: '',
      upgrade_type: (this.version === 'blackipv2' || this.version === 'blackipv3') ? 'realtime' : 'upgrade',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() // 大于今天的禁用
        }
      },
      parmas: {
        version: this.version,
        page: 1,
        page_size: 10
      },
      tableData: [],
      total: 0,
      loading: false
    }
  },
  methods: {
    /**
     * 页码变化
     * @param value: 页码
     */
    pageChange (value) {
      this.parmas.page = value
      this.getTableData()
    },

    /**
     * 日期选择器变化
     * @param value: yyyy-MM-dd | null
     */
    dateChange (value) {
      if (!value) {
        return
      }
      this.parmas.page = 1
      this.getTableData()
    },

    /**
     * 更新包类型变化
     */
    upgradeTypeChange () {
      this.parmas.page = 1
      this.getTableData()
    },

    /**
     * 给日期选择器赋值
     */
    setDatePickerValue () {
      this.date = formatDate(new Date(), 'yyyy-MM-dd')
    },

    /**
     * 获取表格数据
     */
    async getTableData () {
      this.parmas.date = this.date + ' 00:00'
      this.parmas.upgrade_type = this.upgrade_type
      this.loading = true
      const result = await getIpUpdatePackageData(this.parmas).then((res) => {
        return res
      }).catch((err) => {
        return err
      })
      this.loading = false
      if (result.status === 200) {
        this.tableData = result.data.data
        this.total = result.data.total
      } else {
        this.tableData = []
        this.total = 0
      }
    }
  },
  created () {
    this.setDatePickerValue()
    this.getTableData()
  }
}
</script>

<style lang="scss" scoped>
.update-package-wrapper {
  margin-top: 35px;
  .header {
    display: flex;
    align-items: center;
    .label {
      font-size: 16px;
      font-weight: 500;
      color: rgba(112, 119, 141, 1);
      line-height: 22px;
      margin-right: 24px;
    }
    .el-date-editor {
      margin-right: 24px;
    }
  }
  .pagination-box {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #003d92;
    }
  }
}
</style>
